export default {
    CHECK_BOX_SIZE: 18,
    CHECK_BOX_SIZE_SMALL: 12,
    PROGRESS_BAR_HEIGHT: 4,
    NO_DATA_MIN_HEIGHT: "5em",
    SCROLL_EXTRA_SPACE: "14px",
    SLIDER_HANDLE_SIZE: 8,
    SLIDER_HANDLE_BORDER: 3,
    SLIDER_BAR_HEIGHT: 4,
    DATA_GRID_SEARCH_PANEL_WIDTH: 300,
    RADIO_BUTTON_ICON_SIZE: 12,
    VIRTUAL_SCROLL_BAR_WIDTH: 10,
    VIRTUAL_SCROLL_BAR_RIGHT_SPACE: 2,
    RESIZABLE_HANDLER_SIZE: 10,
    RESIZABLE_HANDLER_ICON_SIZE: 8,
    LOAD_INDICATOR_SIZE: 50
};
